import React, { useEffect, useRef } from 'react';
import { FiGithub, FiLinkedin, FiTwitter } from 'react-icons/fi';

const Hero = () => {
  const heroRef = useRef(null);
  
  useEffect(() => {
    const currentRef = heroRef.current;
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate-fadeInUp');
        }
      });
    }, { threshold: 0.1 });
    
    if (currentRef) {
      observer.observe(currentRef);
    }
    
    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, []);

  return (
    <section ref={heroRef} className="flex items-center pt-0 pb-16 bg-white/95 dark:bg-gray-900/95 overflow-hidden min-h-[90vh]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center pt-16">
          <div className="opacity-1 transform translate-y-10">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight text-black dark:text-white">
              Hi, I'm <span className="text-indigo-600 dark:text-indigo-400">Sagar Athinarapu</span>
            </h1>
            <h2 className="text-2xl md:text-3xl mt-4 text-black dark:text-gray-300 font-bold">
              Sr.Software Engineer
            </h2>
            <p className="mt-6 text-lg text-black dark:text-gray-400 max-w-2xl font-semibold">
              I'm a seasoned Software Engineer focused on building fast and secure applications that deliver real business value. Over the past 4+ years, I've successfully applied my skills in Fintech, Healthcare, and E-commerce, most notably by helping cut loan approval times in half and boosting patient service efficiency by 40%. I'm an expert in backend microservices using Java and the Spring framework. I deploy to the cloud using AWS, Kubernetes, and Terraform, manage event flow with Kafka, and ensure system security with OAuth2/JWT. I thrive in roles that let me combine my technical depth in CI/CD and full-stack development (React/Angular) to solve mission-critical problems.
            </p>
            
            <div className="mt-8 flex flex-wrap gap-4">
              <a 
                href="#contact" 
                className="px-6 py-3 bg-indigo-600 text-white rounded-md hover:bg-indigo-700 transition-colors shadow-lg shadow-indigo-500/10 font-bold"
              >
                Get in Touch
              </a>
            </div>
            
            <div className="mt-10 flex gap-6">
              <p rel="noopener noreferrer" className="text-black hover:text-indigo-600 dark:text-gray-400 dark:hover:text-indigo-400 transition-colors">
                <FiGithub className="text-2xl" />
              </p>
              <p rel="noopener noreferrer" className="text-black hover:text-indigo-600 dark:text-gray-400 dark:hover:text-indigo-400 transition-colors">
                <FiLinkedin className="text-2xl" />
              </p>
              <p rel="noopener noreferrer" className="text-black hover:text-indigo-600 dark:text-gray-400 dark:hover:text-indigo-400 transition-colors">
                <FiTwitter className="text-2xl" />
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;